module.exports = __webpack_public_path__ + "static/media/artist_review.d43ccbb1.png";